export default class EntityFactory {
    // #region Vars
    _appHost;
    _definitions = [];
    // #endregion
    // #region Constructor
    constructor(appHost) {
        // #region Vars
        this._appHost = appHost;
        // #endregion        
    }
    // #endregion
    // #region Boostrap
    initialize(entities) {
        if (entities) {
            entities.forEach(e => this._definitions.push(e));
        }
    }
    // #endregion
    // #region Core
    rescolveComponent(segment, route = null) {
        // #region Vars
        let tEntity = segment.entity;
        let tName = segment.name;
        let tAddress = "";
        let tDef = null;
        // #endregion
        // #region Check
        if (!tEntity) {
            return undefined;
        }
        // #endregion
        // #region Init
        if (tEntity.segments.length > 0) {
            tName = tEntity.segments[0].name;
        }
        if (tEntity.segments.length > 1) {
            tAddress = this.getEntityPropertyPath(segment.entity);
        }
        else {
            tAddress = segment.name;
        }
        // #endregion        
        // #region Find
        this._definitions.forEach(d => {
            if (tDef) {
                return;
            }
            if (d.mode && d.mode !== '*') {
                if (d.mode !== segment.mode) {
                    return;
                }
            }
            if (d.name && d.name !== '*') {
                if (d.name !== tName) {
                    return;
                }
            }
            if (d.address && d.name !== '*') {
                if (d.address !== tAddress) {
                    return;
                }
            }
            tDef = d;
            {
                return;
            }
        });
        // #endregion
        // #region Props
        let tProp = {};
        if (tDef?.componentProps) {
            Object.keys(tDef.componentProps).forEach((k) => {
                if (k.endsWith('@comp.exp')) {
                    let tName = k.split('@')[0];
                    let tExp = tDef.componentProps[k];
                    let tValue = null;
                    try {
                        tValue = utils.evalExpression({ entity: tEntity, segment: segment, route: route }, tExp);
                    }
                    catch {
                        //DO nothing
                    }
                    tProp[tName] = tValue;
                }
                else {
                    tProp[k] = tDef.componentProps[k];
                }
            });
        }
        // #endregion
        // #region Result
        let tResult = {
            component: tDef?.componentName,
            componentProps: tProp,
            meta: tDef?.meta ?? {}
        };
        // #endregion
        return tResult;
    }
    // #endregion
    // #region Segements
    getEntityFromRoute(route) {
        // #region Vars
        let m = route;
        let tSegments = [];
        // #endregion
        // #region Parsing
        let tSegs = [];
        {
            for (let s of route.params.segement) {
                // #region Vars
                let tSeg = {
                    name: s,
                    keys: []
                };
                // #endregion
                // #region Query
                let tIndexParams = tSeg.name.indexOf('&');
                {
                    if (tIndexParams > 0) {
                        tSeg.query = tSeg.name.substring(tIndexParams);
                        tSeg.args = utils.urlParamsToObject(tSeg.query);
                        tSeg.name = tSeg.name.substring(0, tIndexParams);
                    }
                }
                // #endregion                
                // #region Vars
                let tKlammer = tSeg.name.indexOf('(');
                let tDoppelpunkt = tSeg.name.indexOf(':');
                // #endregion                
                // #region Klammer
                if (tKlammer >= 0) {
                    // #region Keys
                    let sKeys = tSeg.name.slice(tKlammer + 1);
                    {
                        // #region End
                        let tEnd = sKeys.lastIndexOf(')');
                        {
                            if (tEnd >= 0) {
                                sKeys = sKeys.slice(0, tEnd);
                            }
                        }
                        // #endregion                 
                    }
                    //Set
                    {
                        tSeg.keys = this.parseKeysString(sKeys);
                    }
                    // #endregion
                    // #region Name
                    tSeg.name = tSeg.name.substring(0, tKlammer);
                    // #endregion
                }
                // #endregion
                // #region Doppelpunkt
                else if (tDoppelpunkt >= 0) {
                    // #region Keys
                    tSeg.keys = this.parseKeysString(tSeg.name.substring(tDoppelpunkt + 1));
                    // #endregion
                    // #region Name
                    tSeg.name = tSeg.name.substring(0, tDoppelpunkt);
                    // #endregion
                }
                // #endregion
                // #region Mode
                if (tSeg.name.indexOf('~') > 0) {
                    if (!tSeg.args) {
                        tSeg.args = {};
                    }
                    let tArgs1 = tSeg.name.split('~');
                    {
                        tSeg.name = tArgs1[0];
                        tSeg.mode = tArgs1[1];
                        tSeg.args.m = tSeg.mode;
                    }
                }
                // #endregion
                // #region *Push
                tSegs.push(tSeg);
                // #endregion
            }
        }
        // #endregion
        // #region Build
        for (let tSeg of tSegs) {
            // #region Vars
            let tName = tSeg.name;
            let tParams = tSeg.args ?? {};
            let tArgs1 = {};
            // #endregion
            // #region Args
            Object.keys(tParams).forEach(s => {
                if (s == "w" || s == "l" || s == "s" || s == "id" || s == "m") {
                    return;
                }
                tArgs1[s] = tParams[s];
            });
            Object.keys(route.params).forEach(s => {
                if (s == "segement") {
                    return;
                }
                tArgs1[s] = route.params[s];
            });
            // #endregion
            // #region Route
            let tSgement = {
                mode: tParams.m ? tParams.m : (tSeg.keys.length > 0 ? 'details' : 'list'),
                name: tName,
                id: this.getRouteKeyAsString(tSeg),
                keys: tSeg.keys,
                path: tSeg.name,
                query: tSeg.query,
                index: tSegments.length,
                ancestor: [...tSegments].reverse(),
                root: tSegments.length > 0 ? tSegments[0] : undefined,
                args: tArgs1,
                params: tParams,
                entity: this.getEntityAddressFromRoute(tSeg, tArgs1, tSegments.length > 0 ? tSegments[0].entity : undefined),
                navigation: {
                    id: utils.createId(),
                    mode: tParams['w'] ?? 'default',
                    location: tParams['l'],
                    size: tParams['s'],
                    allowAnonymous: m.meta.allowAnonymous,
                    title: m.meta.title,
                    layout: m.meta.layout,
                    meta: m.meta,
                    isModal: false,
                    isActive: false,
                    isTest: m.meta.isTest,
                    isClosable: tSegments.length > 0,
                }
            };
            //Push
            {
                tSegments.push(tSgement);
            }
            // #endregion
            // #region Component
            let tComponent = this.rescolveComponent(tSgement, route);
            {
                if (tComponent) {
                    // #region Set
                    tSgement.component = tComponent;
                    // #endregion
                    // #region Data
                    let tMeta = tComponent.meta;
                    let tNav = tSgement.navigation;
                    // #endregion
                    // #region Merge
                    if (tMeta) {
                        if (tMeta.mode && tNav.mode === 'default') {
                            tNav.mode = tMeta.mode;
                        }
                        if (!tNav.location && tMeta.location) {
                            tNav.location = tMeta.location;
                        }
                        if (!tNav.size && tMeta.size) {
                            tNav.size = tMeta.size;
                        }
                    }
                    // #endregion
                    // #region Modal
                    if (tNav.mode === 'slide' || tNav.mode === 'popup' || tNav.mode === 'modal') {
                        tNav.isModal = true;
                    }
                    // #endregion
                }
            }
            // #endregion
        }
        // #endregion
        // #region Optimize
        let tLast = null;
        {
            tSegments.forEach(e => {
                if (!e.navigation.isModal) {
                    tLast = e;
                }
            });
            if (tLast) {
                tLast.navigation.isActive = true;
            }
            if (tLast) {
                let tLastIndex = tSegments.indexOf(tLast);
                let tIndex = 0;
                tSegments.forEach(s => {
                    if (tIndex > tLastIndex && s.navigation.isModal) {
                        s.navigation.isActive = true;
                    }
                    tIndex = tIndex + 1;
                });
            }
        }
        // #endregion
        // #region Log
        utils.logTrace("EntityFactory[getEntityFromRoute()]", { segments: tSegments, last: tLast, route: route });
        // #endregion        
        return {
            items: tSegments,
            current: tLast,
        };
    }
    parseKeysString(sKeys) {
        // #region Parse
        //Vars
        let tIsInStr = false;
        let tKeys = [];
        let tKey = undefined;
        //Parse
        for (let l of sKeys) {
            // #region Text
            if (l === '\'') {
                //Ende
                if (tIsInStr) {
                    tIsInStr = false;
                }
                //Begin
                else {
                    if (!tKey) {
                        tKey = { isString: true, name: '', value: '' };
                        tKeys.push(tKey);
                    }
                    else {
                        tKey.isString = true;
                    }
                    tIsInStr = true;
                }
            }
            // #endregion
            // #region Next
            else if (l === ',' && !tIsInStr) {
                tKey = undefined;
            }
            // #endregion
            // #region Seperator
            else if (l === '=' && !tIsInStr && tKey) {
                tKey.name = tKey.value;
                tKey.value = '';
            }
            // #endregion
            // #region Default
            else {
                if (!tKey) {
                    tKey = { isString: false, name: '', value: '' };
                    tKeys.push(tKey);
                }
                tKey.value += l;
            }
            // #endregion
        }
        // #endregion
        return tKeys;
    }
    getRouteKeyOrObject(segment) {
        // #region Empty
        if (segment.keys.length == 0) {
            return undefined;
        }
        // #endregion
        // #region Single
        else if (segment.keys.length == 1) {
            return segment.keys[0].value;
        }
        // #endregion
        // #region Complex
        else if (segment.keys.length > 1) {
            let tKey = {};
            {
                for (let t1 of segment.keys) {
                    tKey[t1.name] = t1.value;
                }
            }
            return tKey;
        }
        // #endregion
    }
    getRouteKeyAsString(segment) {
        // #region Empty
        if (segment.keys.length == 0) {
            return undefined;
        }
        // #endregion
        // #region Single
        else if (segment.keys.length == 1) {
            return segment.keys[0].value;
        }
        // #endregion
        // #region Complex
        else if (segment.keys.length > 1) {
            let tKey = {};
            {
                for (let t1 of segment.keys) {
                    tKey[t1.name] = t1.value;
                }
            }
            return this.getKeyAsString(tKey);
        }
        // #endregion
    }
    getEntityAddressFromRoute(current, args, parentEntity) {
        // #region Check
        if (!current) {
            return undefined;
        }
        // #endregion
        // #region Clone
        let tEntity;
        {
            if (parentEntity) {
                tEntity = utils.cloneDeep(parentEntity);
            }
            else {
                tEntity = {
                    domain: args["domain"],
                    namespace: args["namespace"],
                    segments: []
                };
            }
        }
        // #endregion
        // #region Entity
        if (current.keys.length > 0) {
            if (tEntity.segments.length == 0 || tEntity.segments[tEntity.segments.length - 1].id) {
                tEntity.segments.push({
                    name: current.name,
                    id: this.getRouteKeyOrObject(current),
                });
            }
            else {
                tEntity.segments[tEntity.segments.length - 1].id = this.getRouteKeyOrObject(current);
            }
        }
        else {
            tEntity.segments.push({
                name: current.name
            });
        }
        // #endregion
        return tEntity;
    }
    // #endregion
    // #region Utils
    hasEntity(entity) {
        if (!entity?.segments) {
            return false;
        }
        if (entity.segments.length === 0) {
            return false;
        }
        return true;
    }
    getKeyAsString(object, keys = undefined) {
        // #region Simple
        if (utils.isString(object)) {
            return object;
        }
        else if (keys && keys.length == 1) {
            return utils.getObjectValue(object, keys[0]);
        }
        // #endregion
        // #region Object
        else if (keys) {
            let tKey = {};
            {
                keys.forEach(k => {
                    tKey[k] = utils.getObjectValue(object, k);
                });
            }
            return "j_" + utils.encodeBase64(JSON.stringify(tKey));
        }
        else {
            return "j_" + utils.encodeBase64(JSON.stringify(object));
        }
        // #endregion
    }
    getEntityAddress(entity) {
        // #region Check
        if (!this.hasEntity(entity)) {
            return '';
        }
        // #endregion
        // #region Vars
        let tAddress = entity.namespace;
        // #endregion
        // #region Fill
        entity?.segments.forEach(s => {
            tAddress += '/';
            if (s.id) {
                tAddress += s.name + '(' + this.getKeyAsString(s.id) + ')';
            }
            else {
                tAddress += s.name;
            }
        });
        // #endregion
        return tAddress;
    }
    getEntityAddressForParent(entity) {
        // #region Check       
        if (!this.hasEntity(entity)) {
            return '';
        }
        // #endregion
        // #region Vars
        let tIndex = 0;
        let tAddress = entity.namespace;
        // #endregion
        // #region Vars
        entity?.segments.forEach(s => {
            tIndex = tIndex + 1;
            {
                if (tIndex >= entity.segments.length) {
                    return;
                }
            }
            tAddress += '/';
            if (s.id) {
                tAddress += s.name + '(' + this.getKeyAsString(s.id) + ')';
            }
            else {
                tAddress += s.name;
            }
        });
        // #endregion
        return tAddress;
    }
    getEntityPath(entity) {
        if (!this.hasEntity(entity)) {
            return '';
        }
        let tAddress = entity.namespace?.toLowerCase();
        {
            entity?.segments.forEach(s => {
                tAddress += '/' + s.name?.toLowerCase();
            });
        }
        return tAddress;
    }
    getEntityPropertyPath(entity) {
        if (!this.hasEntity(entity)) {
            return '';
        }
        let tAddress = '';
        {
            entity?.segments?.slice(1)?.forEach(s => {
                if (tAddress) {
                    tAddress += '/';
                }
                tAddress += s.name;
            });
        }
        return tAddress;
    }
    isSingleEntity(entity) {
        if (!entity?.segments) {
            return false;
        }
        if (entity.segments.length === 0) {
            return false;
        }
        if (utils.isNullOrEmpty(entity.segments[entity.segments.length - 1].id)) {
            return false;
        }
        return true;
    }
    getEntityForField(entity, fieldName) {
        let tNew = utils.cloneDeep(entity);
        {
            tNew.segments.push({
                name: fieldName,
            });
        }
        return tNew;
    }
    getEntityForID(entity, id) {
        let tNew = utils.cloneDeep(entity);
        {
            if (tNew.segments.length > 0) {
                tNew.segments[tNew.segments.length - 1].id = id;
            }
        }
        return tNew;
    }
    getEntityForObject(entity, object, keys, fieldName = undefined) {
        let tNew = utils.cloneDeep(entity);
        {
            if (fieldName) {
                tNew.segments.push({
                    name: fieldName,
                    id: this.getKeyAsString(object, keys),
                });
            }
            else if (tNew.segments.length > 0) {
                tNew.segments[tNew.segments.length - 1].id = this.getKeyAsString(object, keys);
            }
        }
        return tNew;
    }
}
